module.exports = __webpack_public_path__ + "static/img/gaozhonghuaxue.0a5e170e.jpg";